import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { logEvent } from '../../../new-lib/analytics';
import { EntityTypes } from '../../../new-lib/constants/common';

interface AreasProps {
  areas: any;
  entityType: EntityTypes;
}

const Areas = ({ areas, entityType }: AreasProps) => {
  const { t } = useTranslation('common');
  const { locale } = useRouter();
  return (
    <AreasContainer>
      <h2 className="headline-3">
        {locale === 'en'
          ? t(entityType) + ' ' + t('areas')
          : t('areas') + ' ' + 'المطور'}
      </h2>
      <div className="areas">
        {areas.map((area: any) => {
          return (
            <Link
              href={`/area/${area.slug}`}
              key={area.id}
              onClick={() =>
                logEvent.click('area_click', 'Developer page', 'area', {
                  area_id: area.id,
                  area_name: area.name
                })
              }
            >
              {area.name}
            </Link>
          );
        })}
      </div>
    </AreasContainer>
  );
};
const AreasContainer = styled.div`
  h2 {
    margin-bottom: 8px;
  }
  .areas {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
    overflow-x: hidden;
    a {
      padding: 7px 12px;
      background: ${props => props.theme.light.colors.whitish};
      border-radius: 7.5px;
      font-family: materialMedium;
      font-size: ${props => props.theme.font.sizes.s};
      color: ${props => props.theme.light.colors.black};
      white-space: nowrap;
      border: 1px solid transparent;
    }
  }

  @media (min-width: ${props => props.theme.breakPoints.desktop.min}) {
    .areas > a:hover {
      color: ${props => props.theme.light.colors.secondary};
      border: ${props => `1px solid ${props.theme.light.colors.secondary}`};
    }
  }
  @media (max-width: ${props => props.theme.breakPoints.tablet.max}) {
    h2 {
      font-size: ${props => props.theme.font.sizes.l};
      margin-bottom: 5px;
    }

    .areas > a {
      font-size: ${props => props.theme.font.sizes.xs};
    }
  }
`;
export default Areas;
